/** ../page-slug/[dataRowId]... */
export const PAGE_CONTEXT_DATA_ROW_ID_URL_ROUTE_PARAM = 'dataRowId';
/** ?pid=[xxx] */
export const PAGE_CONTEXT_ID_URL_QUERY_PARAM = 'pid';
